import {AlreadyLikedIcon, LikeIcon} from "@/components/icons";
import AppContext from "@/context/AppContext";
import {createLikedSong, deleteLikedSong, useLikedSong} from "@/lib/api";
import {Button, SvgIcon, Tooltip} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import theme from "@/styles/theme";

export const LikeSongButton = ({track, onLike, colorSecondary=false}) => {
    const {user} = useContext(AppContext);
    const {likedSong, isLoading, isError, mutate} = useLikedSong(
        track?.id,
        user?.id
    );
    const [liked, setLiked] = useState(true);

    useEffect(() => {
        if (!track) return;

        const likedSongsBase64 = localStorage.getItem("likedSongs");
        const likedSongs = likedSongsBase64 ? JSON.parse(likedSongsBase64) : [];
        const alreadyLiked = likedSongs.findIndex((s) => s === track.id);
        setLiked(alreadyLiked > -1);
    }, [track]);

    useEffect(() => {
        if (!isLoading && !isError) {
            setLiked(likedSong);
        }
    }, [likedSong, isLoading, isError]);

    const like = async() => {
        if (liked) {
            setLiked(false);
            if (likedSong) {
                await deleteLikedSong(likedSong.id);
                mutate();
            }
        } else {
            const likedSongsBase64 = localStorage.getItem("likedSongs");
            let likedSongs = likedSongsBase64 ? JSON.parse(likedSongsBase64) : [];
            likedSongs = [track.id, ...likedSongs];
            localStorage.setItem("likedSongs", JSON.stringify(likedSongs));
            setLiked(true);

            await createLikedSong({song: track.id, user: user?.id});

            if (onLike) {
                onLike();
            }
        }
    };

    const likebutton = {
        padding: "0",
        minWidth: "unset",
        "&::before": {
            content: "''",
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            width: "calc(100% - 0.0625rem)",
            height: "100%",
            backgroundColor: "transparent",
        },
        "&:hover": {
            opacity: "1",
            "&::before": {
                backgroundColor: theme.palette.common.white,
            },
        },
        "& .MuiSvgIcon-root": {
            fontSize: "2.625rem !important",
            transform: "translateY(0.0625rem)",
            "&:hover": {
                "& #likeicon-heart": {
                    fill: colorSecondary ? theme.palette.secondary.main : theme.palette.secondary.main,
                },
                "& #likeicon-check": {
                    fill: colorSecondary ? theme.palette.secondary.main : theme.palette.secondary.main,
                },
            },
            "& #likeicon-heart": {
                fill: colorSecondary ? theme.palette.secondary.main : theme.palette.common.white,
            },
            "& #likeicon-border": {
                fill: colorSecondary ? theme.palette.secondary.main : theme.palette.common.white,
            }
        },
    }

    return (
        <Tooltip
            title={!liked ? "Song gefällt mir" : "Song gefällt mir nicht mehr"}
        >
            <Button aria-label="like" onClick={like} sx={likebutton}>
                <SvgIcon>
                    {liked ? <AlreadyLikedIcon/> : <LikeIcon/>}
                </SvgIcon>
            </Button>
        </Tooltip>
    );
};
